import {Component, Inject, OnInit} from '@angular/core';
import {environment} from '../../environments/environment';

import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';

import {HttpService} from '../services/HttpService';
import {NotificationService} from '../services/NotificationService';
import {FileUploadService} from '../services/FileUploadService';
import swal from 'sweetalert2';

@Component({
    selector: 'app-edit-suggestion',
    templateUrl: './edit-suggestion.component.html',
    styleUrls: ['./edit-suggestion.component.scss'],
    providers: [HttpService, NotificationService, FileUploadService]
})
export class EditSuggestionComponent implements OnInit {

    public apiUrl = environment.apiUrl;

    public User_Details: any;
    public suggestionDetails = {
        id: 0,
        title: '',
        description: '',
        brand_id: 0,
        photos: []
    }

    public loading: boolean = false;
    public allBrands: any;


    constructor(
        public dialogRef: MatDialogRef<EditSuggestionComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        public http: HttpService,
        public notification: NotificationService,
        public fileUpload: FileUploadService
    ) {
    }

    ngOnInit() {
        this.User_Details = JSON.parse(localStorage.getItem('Admin_User_Details'));
        this.suggestionDetails = this.data.suggestionDetails;
        this.allBrands = this.data.allBrands;
    }

    fileChange(event) {
        const selected = event.target.files && event.target.files[0];
        if (!this.fileUpload.isValidImageFile(selected)) {
            this.notification.showNotification('Please select an image file (JPG or PNG).', 'Invalid file', 'error');
            event.target.value = '';
            return;
        }
        this.loading = true;
        this.fileUpload.uploadFile('admin/user/suggestion/addimage', event.target.files,
            {
                token: this.User_Details.token,
                id: this.suggestionDetails.id
            })
        .subscribe(
            (response) => {
                this.loading = false;
                console.log(response);
                if (response.data) {
                    console.log(response.data);
                    this.suggestionDetails.photos.push(response.data);
                }
                else {
                    this.notification.showNotification('Could not upload the image', 'Error', 'error');

                }
            },
            (error) => {
                this.loading = false;
                console.log(error);
                this.notification.showNotification('Could not upload the image', 'Error', 'error');
            }
        )
        //
    }

    updateSuggestion() {
        this.loading = true;
        this.http.makeRequestPost(['admin/user/suggestion/updatesuggestion', {
            token: this.User_Details.token,
            id: this.suggestionDetails.id,
            title: this.suggestionDetails.title,
            description: this.suggestionDetails.description,
            brand_id: this.suggestionDetails.brand_id
        }])
        .subscribe(
            (response) => {
                this.loading = false;
                if (response.data) {
                    this.suggestionDetails = response.data;
                    this.dialogRef.close({changedSuggestion: this.suggestionDetails});
                }
                if (response.error) {
                    this.notification.showNotification('Could not update the suggestion', 'Error', 'error');
                }
            },
            (error) => {
                this.loading = false;
                this.notification.showNotification('Please make sure you have a working data connection', 'Error', 'error');
            }
        )
    }

    deleteSuggestionImage(photo) {
        swal({
            title: 'Confirmation',
            text: 'Are you sure you want to delete this image?',
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes',
            buttonsStyling: false,
            imageUrl: 'assets/img/Popup_Squirrel.png',
            imageWidth: 100,
            showCloseButton: true,
            animation: false,
            confirmButtonClass: 'btn btn-orange btn-block btn-full input-block-level',
            cancelButtonClass: 'btn btn-orange-outline btn-block btn-full input-block-level',
            reverseButtons: true
        }).then((data) => {
            if (data.value) {
                this.loading = true;
                this.http.makeRequestPost(['admin/user/suggestion/image/delete', {
                    token: this.User_Details.token,
                    id: this.suggestionDetails.id,
                    photo_id: photo.id
                }])
                .subscribe(
                    (response) => {
                        this.loading = false;
                        if (response.data) {
                            this.suggestionDetails.photos = response.data;
                        }
                        if (response.error) {
                            this.notification.showNotification('Could not remove the image', 'Error', 'error');
                        }
                    },
                    (error) => {
                        this.loading = false;
                        this.notification.showNotification('Please make sure you have a working data connection', 'Error', 'error');
                    }
                )
            }

        })

    }

}



// WEBPACK FOOTER //
// ./src/app/edit-suggestion/edit-suggestion.component.ts